module Meevo.Components.Controls.SmartMover {
    import ServiceCategory = Model.ServiceCategory;


    export class ServiceCategoriesCollection extends SmartMoverApiCollection<ServiceCategory> implements IApiCollection<ServiceCategory> {

        protected get smartMoverHiddenValue() {
            return SmartMoverHiddenValue.EmptyArray;
        }

        get url() {
            return 'serviceCategory';
        }
    }

}